const Intro = () => {
    return(
        <div className="flex justify-center items-center w-screen h-screen bg-black">
            <img className="w-2/5 h-2/5 flex fixed z-10 object-cover bg-black" src="/loading/loading.gif" alt="cannot find resource"/>
        </div>
    )
}


export default Intro